import { Typography } from '@material-ui/core'
import { MenuItem } from './MenuItem'
import { Redirect, useParams } from 'react-router-dom'
import { useUserProfile } from '../api'
import {
  CloseIcon,
  Logo,
  // LogsIcon,
  ProfileIcon,
  SignoutIcon,
  StatsIcon,
} from '../icons'
import { useToken } from '../App'
// import AllInboxIcon from '@material-ui/icons/AllInbox'

export function UserMenu() {
  const { userRole } = useToken()
  const { userId } = useParams<any>()
  const { userProfile } = useUserProfile(userId)

  if (!userProfile) return null

  if (userRole === 'regular' && !userProfile.phoneVerified)
    return <Redirect to="/verify" />

  return (
    <>
      {userRole === 'regular' ? (
        <Logo />
      ) : (
        <MenuItem route="/users" icon={CloseIcon} />
      )}
      <Typography style={{ color: '#fff', flexGrow: 1 }}>
        {userProfile?.fullname}
      </Typography>
      <MenuItem route={`/user/:userId/profile`} icon={ProfileIcon} />
      {/* {userRole === 'regular' && <MenuItem route="/rinex/new" icon={AllInboxIcon} />} */}
      <MenuItem route={`/user/:userId/stats`} icon={StatsIcon} />
      {/*{userRole === 'admin' && <MenuItem route={`/user/:userId/history`} icon={LogsIcon} />}*/}
      {userRole === 'regular' && (
        <MenuItem route="/auth/signout" icon={SignoutIcon} />
      )}
    </>
  )
}
